import type { AdvancedFilterValueUnion } from "../../types/filters";

/** Archived status on the RAW dashboards. Not a member of `RawStatusCode`, so defined explicitly. */
export const ARCHIVED_STATUS_CODE = "ARCHIVED";

/** Unpublished status on the EDITORIAL dashboards. Editorial content has no "archived" state. */
export const UNPUBLISHED_STATUS_CODE = "UNPUBLISHED";

export function isShowArchivedOn(filtersValues: Record<string, AdvancedFilterValueUnion>): boolean {
  return isToggleOn(filtersValues, "showArchived");
}

export function isShowUnpublishedOn(filtersValues: Record<string, AdvancedFilterValueUnion>): boolean {
  return isToggleOn(filtersValues, "showUnpublished");
}

function isToggleOn(filtersValues: Record<string, AdvancedFilterValueUnion>, key: string): boolean {
  const entry = filtersValues[key];
  return entry?.type === "toggle" && entry.value === true;
}
